import { ArrowUpIcon } from "@heroicons/react/24/outline";
export interface IStateNameCount {
  icon?: JSX.Element;
  stateName?: string;
  cityName?: string;
  value?: string;
  containerClass?: string;
  iconClass?: string;
}

export default function StateCityNameCard({
  icon,
  stateName,
  cityName,
  value,
  containerClass,
  iconClass,
}: IStateNameCount) {
  return (
    <div className={`${containerClass} flex gap-2  pb-3 items-center`}>
      <section className={`size-6 flex ${iconClass}`}>{icon}</section>
      <section className="flex flex-col min-w-[47%]">
        <p className="font-extrabold text-xs">{cityName}</p>
        <p className="text-xs text-darkGray font-semibold">{stateName}</p>
      </section>
      <section className="flex  text-green-600 gap-1 items-center justify-center rounded-md bg-green-600/10 px-2 py-0.5">
        <p className="">{<ArrowUpIcon className="  size-3" />}</p>
        <p className="font-semibold text-xs">{value}</p>
      </section>
    </div>
  );
}
